


























import { Component, Vue } from "vue-property-decorator";

import { AuthService, AuthUserDTO, RoleService } from "@/common/api";
import AccountEditComponent from "@/components/admin/account/accountEditComponent.vue";
import meEditComponent from "@/components/admin/account/meEditComponent.vue";
import LogRocket from "logrocket";
import { namespace } from "vuex-class";
const authStore = namespace("Auth");
@Component({
  name: "QNav",
  components: { AccountEditComponent, meEditComponent },
})
export default class QNav extends Vue {
  @authStore.Getter
  public loggingName!: string;

  @authStore.Getter
  public getIsOpen!: boolean;

  @authStore.Action
  public updateIsOpen!: (status: boolean) => void;
  public user: AuthUserDTO = null;

  public roles = [];

  public showInfo() {
    this.$emit("showUserInfo");
  }

  public async mounted() {
    await Promise.all([this.getMe(), this.getRoles()]);
    if (this.user) {
      LogRocket.identify(this.user.id.toString(), {
        name: this.getName(this.user),
        roleType: this.user.role.display_name,
      });
    }
  }

  public async getMe() {
    const result = await AuthService.me({});
    this.user = result.data.user;
  }

  public async getRoles() {
    const result = await RoleService.adminRole({});
    this.roles = result.data.roles;
  }

  public showEditPopup(user = null) {
    (this.$refs.meEditPopup as meEditComponent).show(user);
  }

  public getName(user = null) {
    return user?.name;
  }
}
